var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ParentPage"},[_c('LeftSideBar',{staticClass:"ParentPage__leftsidebar"},[_c('MenuGenerator',{attrs:{"menu":_vm.menu}})],1),_c('div',{staticClass:"ParentPage__wrapper"},[_c('div',{staticClass:"ParentPage__main"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }